<template>
   <div class="">
    <router-link  class="mr-3 btn btn-info" :to="{name: 'CreateNonWetProductsCategories', query: {catId: data.id, companyId: $route.query.companyId}}">
      {{$t('text.actionButtons.edit')}}
    </router-link>
    <button  class="btn btn-danger" @click="deleteCategories">
      {{$t('text.actionButtons.delete')}}
    </button>
  </div>
</template>

<script>
import configObject from "@/config";
import Jquery from "jquery";
let $ = Jquery;

export default {
  data() {
    return {
      data: {},
    };
  },
  mounted() {
      
  },
  methods: {
    deleteCategories() {
        const deleteConfirm = window.confirm("Are you sure you want to delete this category?");
        if(deleteConfirm){
            this.axios.delete(`${configObject.apiBaseUrl}/NonWetProduct/Product/Category/Delete/${this.data.id}`, configObject.authConfig())
                .then(() => {                
                    this.$toast.open({
                        message: "Successfully deleted  category",
                        type: 'success',
                        duration: 5000
                    });
                    this.$eventHub.$emit("renderNonWetProductsCategories")
                }).catch(error => {       
                    this.$toast.open({
                        message: error.response.data.message ,
                        type: 'error',
                        duration: 5000
                    });
            });
        }
    }
  },
};

</script>